import { Provider } from 'react-redux';
import debounce from 'debounce';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { store } from './app/store';
import { saveState } from './localStorage';

// ----------------------------------------------------------------------

store.subscribe(
  // we use debounce to save the state once each 800ms
  // for better performances in case multiple changes occur in a short time
  debounce(() => {
    saveState(store.getState());
  }, 800)
);

if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development') {
  console.log('development mode');
}

export default function App() {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <ScrollToTop />
        <BaseOptionChartStyle />
        <Router />
      </Provider>
    </ThemeProvider>
  );
}
